<template>
    <div class="modal-content">
        <div class="modal-header">
            <h5 class="modal-title" id="welcome-video-modal-label">
                {{ $root.text('JCB Toolbox training video', null, true) }}
            </h5>
            <button v-if="watched" type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
            </button>
        </div>
        <div class="modal-body" style="overflow: hidden">
            <p>
                {{
                    $root.text(
                        'Welcome to the JCB Marketing Toolbox, to complete your application you need to watch this '
                            + 'training video which covers useful functions such as search, creating personalised '
                            + 'templates and resizing images.',
                        null,
                        true
                    )
                }}
            </p>
            <div class="video-area" @click="controlVideo()" :style="(!played || playing) ? 'cursor: pointer' : ''">
                <video
                    id="welcome-video"
                    width="100%"
                    disablePictureInPicture="true"
                    v-on:canplay="onCanPlay()"
                    v-on:ended="onEnded()"
                ><!--canplaythrough-->
                    <source :src="getVideoSrc()" type="video/mp4">
                    Your browser does not support the video tag.
                </video>
            
                <div v-if="!loaded" class="loading-spinner">
                    <loading></loading>
                </div>
                <div
                    v-if="loaded && (!played || paused)"
                    class="text-center play-button"
                >
                    <a
                        class="text-white"
                        :key="'play-button'"
                        style="position: absolute"
                    >
                        <i class="far fa-circle-play fa-4x"></i>
                    </a>
                    <a class="text-dark" :key="'play-button-bg'">
                        <i class="fas fa-circle fa-4x"></i>
                    </a>
                </div>
                <div
                    v-if="loaded && played && !paused && playing"
                    class="text-center pause-button"
                >
                    <a
                        class="text-white"
                        :key="'pause-button'"
                        style="position: absolute"
                    >
                        <i class="far fa-circle-pause fa-4x"></i>
                    </a>
                    <a class="text-dark" :key="'pause-button-bg'">
                        <i class="fas fa-circle fa-4x"></i>
                    </a>
                </div>
            </div>
        </div>
        <div v-if="watched" class="modal-footer">
            <button
                v-if="!playing"
                type="button"
                class="btn btn-primary mr-2"
                @click="watchAgain()"
            >
                <i class="far fa-rotate-left mr-1"></i> {{ $root.text('watch again', null, true) }}
            </button>
            <button type="button" class="btn btn-light" data-dismiss="modal">
                <i class="far fa-times mr-1"></i> {{ $root.text('close', null, true) }}
            </button>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['version'],
        data () {
            return {
                loaded: false,
                played: false,
                watched: false,
                paused: false,
                playing: false
            }
        },
        mounted () {
            //
        },
        methods: {
            reset: function () {
                const welcomeVideo = document.getElementById('welcome-video');
                welcomeVideo.currentTime = 0;
                this.played = false;
                this.watched = false;
                this.paused = false;
                this.playing = false;
            },
            onCanPlay: function () {
                this.loaded = true;
                //console.log('loaded');
            },
            playVideo: function () {
                const welcomeVideo = document.getElementById('welcome-video');
                welcomeVideo.play();
                this.played = true;
                this.paused = false;
                this.playing = true;
                this.$parent.keep_welcome_video_modal = true;
                //console.log('played');
            },
            pauseVideo: function () {
                const welcomeVideo = document.getElementById('welcome-video');
                welcomeVideo.pause();
                this.paused = true;
                //console.log('played');
            },
            onEnded: function () {
                //console.log('watched');
                this.watched = true;
                this.playing = false;
                if (!this.$root.user.welcome_video_watched) {
                    this.updateUserWelcomeVideoWatched();
                }
                this.$root.user.welcome_video_watched = true;
            },
            watchAgain: function () {
                const welcomeVideo = document.getElementById('welcome-video');
                welcomeVideo.currentTime = 0;
                welcomeVideo.play();
                this.playing = true;
            },
            controlVideo: function () {
                if (this.loaded && (!this.played || this.paused)) {
                    this.playVideo();

                    return null;
                }
                if (this.loaded && this.played && !this.paused && this.playing) {
                    this.pauseVideo();
                }
            },
            updateUserWelcomeVideoWatched: function () {
                const url = this.$root.app.api_url + '/' + this.$root.app.client_id + '/user/welcome-video-watched';
                axios({
                    method: 'put',
                    url: url,
                    headers: { 'Authorization': 'Bearer ' + this.$root.token }
                })
                .then(response => {
                    //
                })
                .catch(function (error) {
                    //
                });
            },
            getVideoSrc: function () {
                let src = '/videos/client/welcome-video';
                if (this.version && (this.version != 'en')) {
                    src += ('-' + this.version);
                }
                src += '.mp4';

                return src;
            }
        }
    }
</script>

<style scoped>
    .video-area {
        position: relative;
    }

    .loading-spinner {
        position: absolute;
        top: 0;
        bottom: 0;
        margin: auto;
        width: 100%;
    }

    .play-button, .pause-button {
        position: absolute;
        top: 0;
        bottom: 0;
        margin: auto;
        width: 100%;
        height: 52px;
    }

    .pause-button {
        display: none;
    }

    .video-area:hover .pause-button {
        display: block;
    }
</style>